const MedicineIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 1.625C0.75 1.16016 1.13281 0.75 1.625 0.75H10.375C10.8398 0.75 11.25 1.16016 11.25 1.625V2.5C11.25 2.99219 10.8398 3.375 10.375 3.375H1.625C1.13281 3.375 0.75 2.99219 0.75 2.5V1.625ZM1.625 4.25H10.375V13C10.375 13.9844 9.58203 14.75 8.625 14.75H3.375C2.39062 14.75 1.625 13.9844 1.625 13V4.25ZM5.125 7.3125V8.625H3.8125C3.56641 8.625 3.375 8.84375 3.375 9.0625V9.9375C3.375 10.1836 3.56641 10.375 3.8125 10.375H5.125V11.6875C5.125 11.9336 5.31641 12.125 5.5625 12.125H6.4375C6.65625 12.125 6.875 11.9336 6.875 11.6875V10.375H8.1875C8.40625 10.375 8.625 10.1836 8.625 9.9375V9.0625C8.625 8.84375 8.40625 8.625 8.1875 8.625H6.875V7.3125C6.875 7.09375 6.65625 6.875 6.4375 6.875H5.5625C5.31641 6.875 5.125 7.09375 5.125 7.3125Z"
      fill="#7464B2"
    ></path>
  </svg>
);

export default MedicineIcon;
